<div class="www-partners-benefits">
  <div class="www-partners-benefits__con">
    <p class="www-partners-benefits__con__des">
      Mamy dla Ciebie kody rabatowe do naszych Partnerów, które możesz wykorzystać jednorazowo, kiedy tylko zechcesz.
      <br class="d-none d-md-inline" />
      Pamiętaj, że każdy kod ma swoje unikalne warunki użytkowania – skorzystaj z wyjątkowych możliwości, przestrzegając
      <br class="d-none d-md-inline" />
      regulaminu naszych Partnerów.
    </p>

    <div class="www-partners-benefits__con__swi">
      <swiper-container [config]="swiperConfig" class="www-partners-benefits__con__swi__sli" wwwSwiper init="false">
        @for (r of partnersCodes(); let i = $index; track i) {
          <swiper-slide [ngClass]="{ 'www-partners-benefits__con__swi__sli__sl': true }" swiperSlide role="button">
            <div class="www-partners-benefits__con__swi__sli__sl__box">
              @if (r.list_photo) {
                <img
                  class="www-partners-benefits__con__swi__sli__sl__box__img"
                  [ngSrc]="r.list_photo"
                  [alt]="r.name"
                  [width]="336"
                  [height]="318"
                  [priority]="true"
                />
              }

              <div>
                <h4 class="www-partners-benefits__con__swi__sli__sl__box__tit">
                  {{ r.name }}
                </h4>
                @if (r.short_description) {
                  <p class="www-partners-benefits__con__swi__sli__sl__box__desc" [innerHtml]="r.short_description"></p>
                }
                @if (r.valid_until) {
                  <p class="www-partners-benefits__con__swi__sli__sl__box__dat">
                    WAŻNE DO: {{ r.valid_until | date: 'dd/MM/yyyy' }}
                  </p>
                }
                <a
                  class="www-partners-benefits__con__swi__sli__sl__box__link"
                  (click)="openDetails.emit(r); pushLayer(r.name)"
                >
                  SZCZEGÓŁY
                </a>
              </div>
            </div>
          </swiper-slide>
        }
      </swiper-container>

      <div class="www-partners-benefits__con__swi__nav">
        <div class="www-partners-benefits__con__swi__nav--prev"></div>
        <div class="www-partners-benefits__con__swi__nav--pag"></div>
        <div class="www-partners-benefits__con__swi__nav--next"></div>
      </div>
    </div>
  </div>
</div>
